import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Ponteiro GROSSO (dedo) × fino (mouse).
 *
 * É isto que decide a forma de reordenar uma lista, e NÃO o tamanho da tela: um
 * notebook com janela estreita continua tendo mouse, e um tablet largo continua
 * sendo dedo. Arrastar com o dedo numa página que rola verticalmente disputa com
 * o próprio scroll — por isso o toque ganha SETAS e o mouse ganha a alça.
 *
 * No app nativo a resposta é sempre "grosso" sem consultar mídia: `matchMedia`
 * dentro da WebView já responde certo, mas o curto-circuito evita depender disso.
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(() => {
    if (Capacitor.isNativePlatform()) return true;
    return typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;
  });

  useEffect(() => {
    if (Capacitor.isNativePlatform() || typeof window === 'undefined') return;
    const mq = window.matchMedia('(pointer: coarse)');
    const onChange = (e: MediaQueryListEvent) => setCoarse(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return coarse;
}
